const ESTADOS_FORMULARIO = {
  PENDIENTE: 'Pendiente',
  ADMITIDO: 'Admitido en DINACOPA',
  DESPACHADO: 'Despachado',
  RECIBIDO: 'Recibido'
};

export default ESTADOS_FORMULARIO;
